angular.module('lead')
    .controller('LeadOfferSendEmailController', function ($http, $httpParamSerializer, $q, $rootScope, $scope, $uibModalInstance, data, toastr, LeadOfferService, IdentityService,
                                                          MailPriority, FilesLibrary, FileUploaderLocal, PropertyService, LeadService, PropertyDealService, InvoiceService) {
        this.PropertyService = PropertyService;
        this.LeadService = LeadService;
        this.maxPositions = 7;
        this.assetSorting = [ 'property.type', 'property.buildingNumber', 'property.floor', 'property.number'];
        this.offerAttachmentUploader = FileUploaderLocal.create(() => ({
            type: 'LEAD',
            id: data.id,
            description: 'Załącznik do oferty'
        }));
        this.filesRefreshId = 0;

        this.tinymceOptions = {
            height: 350,
            statusbar: false,
            plugins: "textcolor code table charmap",
            toolbar1: "undo redo | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | blockquote charmap | bullist numlist | outdent indent | table | forecolor backcolor | fontsizeselect | fontselect | code",
            toolbar2: "",
            toolbar_items_size: 'small',
        };

        this.message = {
            disposition_notification: false,
            dsn: false,
            files: [],
            priority: "NORMAL",
            properties: []
        };

        this.$onInit = () => {
            this.questionBeforeSend = false;
            this.lead = data;
            this.message.address = this.lead.sourceEmail || firstContactValue(this.lead.client, 'EMAIL') || "";
            this.projects = this.lead.projects || [];
            this.message.project = this.projects.length === 1 ? this.projects[0] : null;
            this.onProjectChanged();
        };

        this.attachFile = () => FilesLibrary.open().then(selectedFiles => {
            const files = selectedFiles.map(file => Object.assign({}, file, {$offerAttachmentSource: 'LIBRARY'}))
            this.message.files = mergeUniqueFiles(this.message.files, files)
        })
        this.removeFile = $index => this.message.files.splice($index, 1)
        this.removePendingOfferAttachment = item => item.remove()

        function firstContactValue(client, type) {
            const contact = ((client && client.contacts) || []).find(item => item && item.type === type && item.value);
            return contact ? contact.value : null;
        }

        this.hasLeadSourceData = () => !!(this.lead && (this.lead.sourceName || this.lead.sourcePhone || this.lead.sourceEmail));
        this.hasLeadDetails = () => this.hasLeadSourceData() || !!(this.lead && this.lead.client);

        this.refreshFiles = () => {
            const refreshId = ++this.filesRefreshId
            const additionalFiles = this.message.files.filter(file => file.$offerAttachmentSource !== 'PROPERTY')
            const requests = this.message.assets
                .map(p => p.property)
                .map(p => p.id)
                .map(id => $http.get('/crm/api/file-association-property/' + id + "/files")
                    .then(success => success.data)
                    .then(result => result.list.map(item => Object.assign({}, item.file, {$offerAttachmentSource: 'PROPERTY'}))))

            return $q.all(requests).then(fileLists => {
                if (refreshId !== this.filesRefreshId) {
                    return
                }
                const propertyFiles = fileLists.reduce((files, items) => files.concat(items), [])
                this.message.files = mergeUniqueFiles(additionalFiles, propertyFiles)
            })
        }

        MailPriority.query().$promise.then(items => $scope.priorities = items)

        IdentityService.loadIdentities().then(items => {
            this.identities = items
            this.identityChange(items.find(val => val.defaultValue))
        })

        this.identityChange = identity => {
            if (angular.isUndefined(identity) === false) {
                this.message.identity = identity
                this.message.dsn = identity.dsn
                this.message.disposition_notification = identity.disposition_notification
                this.message.text = identity.signature
            }
        }

        this.onProjectChanged = () => {
            this.message.assets = [];
            this.refreshFiles();

            if (this.message.project == null) {
                this.templates = [];
                this.message.tpl = null;
            } else {
                $http.get('/crm/api/lead/' + this.lead.id + "/templates/" + this.message.project.id).then(success => success.data).then(result => {
                    this.templates = result;
                    if (this.templates.length === 1) {
                        this.message.tpl = this.templates[0];
                    } else {
                        this.message.tpl = null;
                    }
                });
            }
        }

        this.selectProperty = projectId => {
            let alreadySelectedIds = this.message.assets.map(p => p.property).map(p => p.id);
            return PropertyService.selectProperty(projectId, alreadySelectedIds, true)
                .then(properties => {
                    properties.forEach(property => {
                        if (!this.message.assets.some(p => p.property.id === property.id)) {
                            if(this.message.assets.length >= this.maxPositions) {
                                toastr.error("Osiągnięto maksymalną liczbę pozycji w ofercie: " + this.maxPositions);
                                return;
                            }
                            this.message.assets.push({
                                type: 'ASSET',
                                property: property,
                                calculationMethod: property.calculationMethod,
                                calculationBasedOn: property.calculationBasedOn,
                                vat: property.vat,
                                pricingBase: property.pricingBase,
                                pricingAttributes: property.pricingAttributes,
                                pricing: property.pricing,
                                attributes: property.attributes
                            });
                        }
                    });
                    this.refreshFiles();
                });
        }

        this.generateOfferPdfUrl = () => {
            let params = {
                tpl: this.message.tpl,
                project: this.message.project ? this.message.project.id : null,
                properties: this.message.assets.map(p => p.property).map(p => p.id).join(","),
            }
            return "/crm/api/lead/" + this.lead.id + "/show-offer?" + $httpParamSerializer(params)
        }

        this.isPdfViewAvailable = () => {
            return this.message.tpl != null && this.message.project != null && this.message.assets.every(p => p.discount == null)
        }

        this.send = () => {
            this.sending = true;
            this.questionBeforeSend = false;
            return this.persistPendingOfferAttachments()
                .then(() => $http.post('/crm/api/lead/' + this.lead.id + "/send-email", this.buildSendPayload()))
                .then(success => success.data)
                .then(result => {
                    toastr.success("Wysłano ofertę");
                    $uibModalInstance.close(result);
                    $rootScope.$broadcast('lead.updated')
                    $rootScope.$broadcast('file.saved')
                })
                .finally(() => {
                    this.sending = false;
                });
        }

        this.buildSendPayload = () => {
            const payload = angular.copy(this.message)
            payload.fileIds = uniqueIds(this.message.files.map(file => file.id))
            delete payload.files
            return payload
        }

        this.persistPendingOfferAttachments = () => {
            return FileUploaderLocal.uploadAll(this.offerAttachmentUploader).then(uploadedFiles => {
                const files = uploadedFiles.map(file => Object.assign({}, file, {$offerAttachmentSource: 'LIBRARY'}))
                this.message.files = mergeUniqueFiles(this.message.files, files)
                this.offerAttachmentUploader.queue.slice().forEach(item => item.remove())
            })
        }

        this.changePrice = item => {
            return PropertyDealService.changePrice(angular.copy(item)).then(result => {
                item.calculationMethod = result.calculationMethod;
                item.calculationBasedOn = result.calculationBasedOn;
                item.vat = result.vat;
                item.pricingBase = result.pricingBase;
                item.pricing = result.pricing;
                item.pricingAttributes = result.pricingAttributes;
                item.pricingRegular = result.pricingRegular;
                item.discount = {
                    totalNet: InvoiceService.sub(item.pricing.totalNet, item.pricingRegular.totalNet),
                    totalGross: InvoiceService.sub(item.pricing.totalGross, item.pricingRegular.totalGross),
                }
            })
        }

        this.toggleShowDiscounts = () => {
            this.showDiscounts = !this.showDiscounts;
        }

        this.deleteAsset = (index) => {
            this.message.assets.splice(index, 1);
            this.refreshFiles();
        }

        this.sortAsset = sort => {
            if(angular.equals(this.assetSorting, sort)) { //equals string + equals array
                if(this.assetSorting instanceof Array) {
                    this.assetSorting = this.assetSorting.map(value => "-" + value);
                }
                else {
                    this.assetSorting = "-" + sort;
                }
                return
            }
            this.assetSorting = sort;
        }

        this.cancel = () => {
            this.offerAttachmentUploader.queue.slice().forEach(item => item.remove())
            $uibModalInstance.dismiss('cancel')
        }

        function mergeUniqueFiles(currentFiles, addedFiles) {
            const filesById = new Map()
            const files = (currentFiles || []).concat(addedFiles || [])
            files.forEach(file => {
                const currentFile = file && filesById.get(file.id)
                if (file && file.id != null && (!currentFile || fileSourcePriority(file) > fileSourcePriority(currentFile))) {
                    filesById.set(file.id, file)
                }
            })
            return Array.from(filesById.values())
        }

        function fileSourcePriority(file) {
            return {
                PROPERTY: 1,
                LIBRARY: 2
            }[file.$offerAttachmentSource] || 2
        }

        function uniqueIds(ids) {
            return Array.from(new Set((ids || []).filter(id => id != null)))
        }
    })
